import { css } from '@emotion/css';
import { Switch } from '@grafana/ui';
import React from 'react';

const EditorSwitch = (props) => {
  const styles = getStyles();
  return /* @__PURE__ */ React.createElement("div", { className: styles.switch }, /* @__PURE__ */ React.createElement(Switch, { ...props }));
};
const getStyles = () => {
  return {
    switch: css({
      display: "flex",
      alignItems: "center",
      minHeight: 30
    })
  };
};

export { EditorSwitch };
//# sourceMappingURL=EditorSwitch.js.map
